import type { ReactNode } from "react";

export type Rang1OnlyNoticeProps = { children: ReactNode };

/**
 * Why a screen reserved to the rang 1 is read-only (N59): shown before any
 * click, the API would otherwise refuse at the end.
 */
export function Rang1OnlyNotice({ children }: Rang1OnlyNoticeProps) {
  return (
    <p className="mt-2 rounded-md bg-amber-50 px-3 py-2 text-sm text-amber-800 dark:bg-amber-950/30 dark:text-amber-300">
      {children}
    </p>
  );
}
